<template>
<div class="page page_publishDZ nobg">
	<!-- 发布信息 -->
	<div class="xinxi">
		<div class="item">
			<div class="item_l">
				<span class="tag_required">*</span>
				<span class="">分类：</span>
			</div>
			<div class="item_r">
				<van-field v-model="cate"  placeholder="请选择分类" readonly @click="show_cate = true"/>
			</div>
		</div>
		<div class="item">
			<div class="item_l">
				<span class="tag_required">*</span>
				<span class="">标题：</span>
			</div>
			<div class="item_r">
				<van-field v-model="title"  placeholder="请填写标题" />
			</div>
		</div>
		<div class="item">
			<div class="item_l">
				<span class="tag_required">*</span>
				<span class="">预估价格：</span>
			</div>
			<div class="item_r">
				<van-field v-model="priceRange"  placeholder="请填写价格区间" />
			</div>
		</div>
		<!-- 用户发布 无订购量 -->
		<div class="item" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">订购量：</span>
			</div>
			<div class="item_r">
				<van-field v-model="accept_order_count" type="number" placeholder="请填写订购量" />
			</div>
		</div>
		<!-- 用户发布 无定制周期 -->
		<div class="item" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">截止时间：</span>
			</div>
			<div class="item_r">
				<van-field v-model="end_at" placeholder="请选择截止时间" readonly @click="show_end = true"/>
			</div>
		</div>
		<!-- 用户发布 无制作周期 -->
		<div class="item" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">制作周期：</span>
			</div>
			<div class="item_r">
				<van-field v-model="made_cycle"  type="number" placeholder="请填写制作周期" />
			</div>
		</div>
		<!-- 用户发布 无描述 -->
		<div class="item" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">商品描述：</span>
			</div>
			<div class="item_r">
				<van-field v-model="desc"  placeholder="请填写描述信息" />
			</div>
		</div>
		<!-- 内容 -->
		<div class="item textarea">
			<div class="item_l">
				<span class="">内容：</span>
			</div>
			<div class="item_r">
				<van-field v-model="content" type="textarea" placeholder="请填写内容" />
			</div>
		</div>
		<!-- 上传视频 -->
		<!-- <van-uploader :after-read="onReadVideo" :before-delete="imgVideoDel"  v-model="videolist" accept="video/*" max-count="1" class="icon-add">
				<div class="addPhone"></div>
			</van-uploader> -->
		<!-- <div class="uploadTu" v-if="imglist.length == 0 && is_tradesman == 1">
			<div class="title">上传视频/视频:</div>
			<input type="file" accept="video/*" id="videoInput" @change="upVideo">
		</div> -->
		<!-- 上传图片  v-if="videoUploadList.length == 0" -->
		<div class="uploadTu">
			<div class="title">上传图片</div>
			<div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept="image/*" multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
		</div>
		<!-- 分销 -->
		<div class="item flexbetween" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">是否代理商户分销</span>
			</div>
			<div class="item_r">
				<van-checkbox v-model="checked_fenxiao">
					<template #icon="props">
						<img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
					</template>
				</van-checkbox>
			</div>
		</div>
		<div class="item" v-if="checked_fenxiao && is_tradesman == 1">
			<div class="item_l">
				<span class="">分销比例</span>
			</div>
			<div class="item_r">
				<van-field v-model="agent_fx" type="number" placeholder="请设置分销比例" />
			</div>
		</div>
		<!-- 是否开放购买 -->
		<div class="item flexbetween" v-if="is_tradesman == 1">
			<div class="item_l">
				<span class="">是否开放购买</span>
			</div>
			<div class="item_r">
				<van-checkbox v-model="checked_buy">
					<template #icon="props">
						<img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
					</template>
				</van-checkbox>
			</div>
		</div>
		<div class="item" v-if="checked_buy && is_tradesman == 1">
			<div class="item_l">
				<span class="">最终价格：</span>
			</div>
			<div class="item_r">
				<van-field v-model="price" type="number" placeholder="请设置最终价格" />
			</div>
		</div>
	</div>
	<!-- 发布 -->
	<div class="actions" @click="publishFun">
		<div class="bottom_action">发布</div>
	</div>
	<!-- 分类弹层 -->
    <van-popup v-model="show_cate" position="bottom">
        <van-picker show-toolbar :columns="cateList" value-key="title" @confirm="confirmCate" @cancel="show_cate = false"  />
    </van-popup>
	<van-popup v-model="show_end" position="bottom">
        <van-datetime-picker v-model="currentDate" type="date" title="选择时间" :min-date="minDate" @confirm="confirmTime" @cancel="show_end=false" />
    </van-popup>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
			title: null,
			cate: null,
			cateId: null,
			desc: null,
			imglist: [], // 上传的图片
			priceRange: null, //价格区间
			content: null,
			is_tradesman: this.$route.query.is_tradesman,
			show_cate: false,
			show_end: false,
			cateList: [],
			id: this.$route.query.id, // 定制id
			activeIcon: process.env.BASE_URL + 'statics/images/active.png',
			inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
			checked_fenxiao: false,
			agent_fx: null,
			checked_buy: false,
			price: null,
			accept_order_count:null, // 订购量
			end_at: null, // 定制周期
			currentDate: new Date(),
            minDate: new Date(),
			made_cycle: null, // 制作周期
			videolist: [], // 上传的视频列表
			videoUploadList: [] // 上传到服务器的视频列表
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '发布'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
				}
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
			this.token = this.$store.getters.token
        }
		this.getCateList()
		if(this.id){
			this.getDingzhiInfo()
		}
    },
    methods: {
		// 分类
        getCateList() {
            var params = {
                token: this.token
            }
            this.$api.dingzhi.catelist(params).then(res => {
                if (res.code == 200) {
                    var cateList = res.result
                    for (var i in cateList) {
                        cateList[i].active = 0
                    }
                    this.cateList = cateList
                }
            })
        },
		// 选择分类
		confirmCate(val){
			this.cate = val.title
			this.cateId = val.id
			this.show_cate = false
		},
        // 上传图片
		onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
		},
		// 删除视频
		imgVideoDel(){
			var that = this
			that.videolist = []
			that.videoUploadList = []
		},
		confirmTime(value) {
            console.log('confirmTime', value)
            this.end_at = this.formatDate(value)
            this.show_end = false
        },
        formatDate(date) {
            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString();
			var day = date.getDate().toString();
            if (month.length == 1) {
                month = '0' + month;
            }
            if (day.length == 1) {
                day = '0' + day;
			}
            return `${year}-${month}-${day}`;
        },
		// 发布
		publishFun(){
			if(!this.cate){
				this.$toast('请选择分类')
				return
			}
			if(!this.title){
				this.$toast('请填写标题')
				return
			}
			if(!this.priceRange){
				this.$toast('请填写价格区间')
				return
			}
			var params = {
				token: this.token,
				title: this.title,
				custom_made_cate_id: this.cateId
			}
			if(this.is_tradesman){
				params.price_range = this.priceRange
			}else{
				params.price = this.priceRange
			}
			if(this.desc && this.is_tradesman){
				params.descript = this.desc	
			}
			if(this.content){
				params.content = this.content
			}
			if(this.imglist.length != 0){
				params.album = this.imglist.join()
			}
			if(this.videoUploadList.length != 0){
				params.video_url = this.videoUploadList[0]
				params.video_type = 1 // 1上传 0链接  目前只做上传
			}
			if(this.is_tradesman == 1){
				// 是否分销
				if(this.checked_fenxiao){
					params.is_fx = 1
				}else{
					params.is_fx = 0
				}
				// 设置分销比例
				if(this.checked_fenxiao){
					if(!this.agent_fx){
						this.$toast('请设置分销比例')
						return
					}else{
						params.agent_fx = this.agent_fx
					}
				}
				// 是否开放购买
				if(this.checked_buy){
					params.is_buy = 1
				}else{
					params.is_buy = 0
				}
				// 设置分销比例
				if(this.checked_buy){
					if(this.price==null || this.price==undefined || this.price==''){
						this.$toast('请输入最终价格')
						return
					}else{
						params.price = this.price
					}
				}
				// 订购量 0不限制
				if(this.accept_order_count != null && this.accept_order_count != undefined && this.accept_order_count != ''){
					params.accept_order_count = this.accept_order_count
				}
				// 截止日期
				if(this.end_at != null && this.end_at != undefined && this.end_at != ''){
					params.end_at = this.end_at
				}
				// 制作周期
				if(this.made_cycle != null && this.made_cycle != undefined && this.made_cycle != ''){
					params.made_cycle = this.made_cycle
				}
			}
			// 匠人发布
			if(this.is_tradesman == 1){
				this.$api.dingzhi.tradcreate(params).then(res=>{
					if(res.code == 200){
						this.$toast('发布成功,请等待审核')
						if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
							var params = {}
							this.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})
						} else {
							this.$router.back()
						}
						
					}
				})
			}else if(this.is_tradesman == 0){
				// 用户发布
				if(this.id != null){
					params.id = this.id
					// 再次编辑发布
					this.$api.dingzhi.useredit(params).then(res=>{
						if(res.code == 200){
							this.$toast('修改成功,请等待审核')
							if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
								var params = {}
								this.$bridge.callhandler('sdjy://public/back', params, (data) => {

								})
							} else {
								this.$router.back()
							}
						}
					})
				}else{
					// 初次发布
					this.$api.dingzhi.usercreate(params).then(res=>{
						if(res.code == 200){
							this.$toast('发布成功,请等待审核')
							if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
								var params = {}
								this.$bridge.callhandler('sdjy://public/back', params, (data) => {

								})
							} else {
								this.$router.back()
							}
						}
					})
				}
			}
		},
		// 获取定制详情
		getDingzhiInfo(){
			var params = {
				id: this.id
			}
			this.$api.dingzhi.comunitydetail(params).then(res=>{
				if(res.code == 200){
					var info = res.result
					this.cate = info.cate
					this.cateId = info.cate_id
					this.title = info.title
					this.priceRange = info.price
					this.content = info.content
					this.imglist = info.attrShow
				}
			})
		},
		// 上传视频
		onReadVideo: function (file) {
			var that = this
			console.log('视频列表',that.videolist)
            that.$api.common.base64video({
                videoFile: file.content
			}).then(res => {
				if (res.code == 200) {
					that.videoUploadList.push(res.result.url)
				}
			});
		},
		// 原生上传图片
		upVideo(event){
			var that = this
			console.log('触发了====')
			var input = document.getElementById('videoInput')
			var videoFile = input.files[0]
			console.log('文件====',videoFile)
			var data = new FormData();
			data.append("imgFile", videoFile);
			console.log('FormData=====',data)
			$.ajax({
                type: 'POST',
                url: '/common/upload/file', // 上传图片
                data: data,
                processData: false, // 告诉jquery要传输data对象
                contentType: false,   //  告诉jquery不需要增加请求头对于contentType的设置
                success: function (arg) {
					console.log('上传了吗',arg)
					if (res.code == 200) {
						that.videoUploadList.push(res.result.url)
					}
                }
            })
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
